import React from "react"
import * as styles from "./content.module.scss"
import parse from "html-react-parser";
import {GatsbyImage, getImage} from "gatsby-plugin-image";

const Content = ({content, visual}) => {

    let description = '';
    let isContent = false;
    let bannerImage = '';
    let bannerAltText = '';

    if (!visual && content !== null) {
        if (content.bannerdescription !== null) {
            isContent = true;
            description = parse(content.bannerdescription);
        }
        if (content.bannercta !== null) {
            isContent = true;
        }
        if (content.bannerimage !== null) {


            const bannerTitle = content.bannerimage.title ? content.bannerimage.title : content.title;
            bannerAltText = content.bannerimage.altText ? content.bannerimage.altText : bannerTitle;
            bannerImage = getImage(content.bannerimage.localFile);
        }
    } else if (visual && content !== null) {
        if (content.visualimage !== null) {
            bannerImage = getImage(content.visualimage.localFile);
        }
    }

    return (
        <section className={styles.bannerSection}>
            <div className={`grid-container-wrap ${!isContent ? `${styles.imageBanner}` : `${styles.bgBanner}`}`}>
                {bannerImage &&
                <figure className={styles.bannerImage}>
                    <GatsbyImage image={bannerImage} alt={bannerAltText}/>
                </figure>
                }
                {isContent && content !== null &&
                <div className="grid-container">
                    <div
                        className="grid-colstart-7-lg-min grid-colend-12-xl-min grid-colend-13-xs-min grid-colstart-6-lg-md grid-colstart-5-md-sm">
                        <div className={styles.bannerContent}>
                            {description}

                            {content.bannercta &&
                            <a href={content.bannercta.url} target={content.bannercta.target}
                               className="btn btn-primary">
                                {content.bannercta.title ? content.bannercta.title : `Lees meer`}
                            </a>
                            }

                        </div>
                    </div>
                </div>
                }
            </div>
        </section>
    )
}

export default Content